/**
 *
 * StudentListItem
 *
 */

import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// antd component
import { List, Tooltip } from "antd";

// icons
import { WarningOutlined } from "@ant-design/icons";

function StudentListItem({
  element,
  searchString,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames("student-list-meta", className);
  const { t } = useTranslation();

  const stdName = `${element?.description?.lastname} ${
    element?.description?.firstname
  }`;

  return (
    element && (
      <List.Item.Meta
        className={childClassNames}
        avatar={
          element?.class_info?.title ? (
            customHighlighter(element?.class_info?.title, searchString)
          ) : (
            <Tooltip
              title={t("classes.fillClassInfo")}
              className="tooltip-std"
              key={"info-" + element?._id}
            >
              <WarningOutlined />
            </Tooltip>
          )
        }
        title={
          <>
            <span className="title">
              {customHighlighter(stdName, searchString)}
            </span>
          </>
        }
      />
    )
  );
}

StudentListItem.defaultProps = {
  dateFormat: "DD.MM.YYYY",
  timeFormat: "HH:mm",
};
StudentListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func,
};

export default memo(StudentListItem);
